import { render } from "./MoonBoard.vue?vue&type=template&id=8411427c&ts=true"
import script from "./MoonBoard.vue?vue&type=script&lang=ts"
export * from "./MoonBoard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__